import React, { useState, useEffect, useCallback, useRef } from 'react';

import imgBobcat from '../projectitems/makineler/bobcat-yukleyici-s130.jpg';
import imgJcbMini from '../projectitems/makineler/jcb-mini-yukleyici-powerboom-155.jpg';
import imgJcbTeleskopik from '../projectitems/makineler/jcb-teleskopik-forklift-30-23d-4wd.jpg';
import imgKomatsu from '../projectitems/makineler/komatsu-forklift-fd30t-17.jpg';
import imgKubotaU10 from '../projectitems/makineler/kubota-ekskavator-u10-3.jpg';
import imgKubotaU36 from '../projectitems/makineler/kubota-mini-ekskavator-u36-4.jpg';
import imgManitouMt from '../projectitems/makineler/manitou-teleskopik-forklift-mt1840-easy-75d-st5-s1.jpg';
import imgTakeuchiTb215 from '../projectitems/makineler/takeuchi-mini-ekskavator-tb215r.jpg';
import imgTakeuchiTbr210 from '../projectitems/makineler/takeuchi-mini-ekskavator-tbr210r.jpg';
import imgManitouMlt from '../projectitems/makineler/teleskopik-forklift-manitou-mlt-625h.jpg';

const machines = [
    { id: 1, image: imgBobcat, title: 'Bobcat Yükleyici S130' },
    { id: 2, image: imgJcbMini, title: 'JCB Mini Yükleyici Powerboom 155' },
    { id: 3, image: imgJcbTeleskopik, title: 'JCB Teleskopik Forklift 30-23D-4WD' },
    { id: 4, image: imgKomatsu, title: 'Komatsu Forklift FD30T-17' },
    { id: 5, image: imgKubotaU10, title: 'Kubota Ekskavatör U10-3' },
    { id: 6, image: imgKubotaU36, title: 'Kubota Mini Ekskavatör U36-4' },
    { id: 7, image: imgManitouMt, title: 'Manitou Teleskopik Forklift MT1840' },
    { id: 8, image: imgTakeuchiTb215, title: 'Takeuchi Mini Ekskavatör TB215R' },
    { id: 9, image: imgTakeuchiTbr210, title: 'Takeuchi Mini Ekskavatör TBR210R' },
    { id: 10, image: imgManitouMlt, title: 'Manitou Teleskopik Forklift MLT 625H' },
];

const total = machines.length;

const getOffset = (index, active) => {
    let diff = index - active;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
};

const SWIPE_THRESHOLD = 50;

const Machines = () => {
    const [active, setActive] = useState(0);
    const touchStartX = useRef(0);

    const next = useCallback(() => {
        setActive((prev) => (prev + 1) % total);
    }, []);

    const prev = useCallback(() => {
        setActive((prev) => (prev - 1 + total) % total);
    }, []);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        const deltaX = e.changedTouches[0].clientX - touchStartX.current;
        if (deltaX < -SWIPE_THRESHOLD) next();
        else if (deltaX > SWIPE_THRESHOLD) prev();
    };

    useEffect(() => {
        const timer = setInterval(next, 3000);
        return () => clearInterval(timer);
    }, [next]);

    return (
        <section className="machines" id="makineler">
            <div className="machines__container">
                <div className="machines__header">
                    <p className="section-eyebrow">Filomuz</p>
                    <h2 className="section-title">İŞ MAKİNELERİMİZ</h2>
                    <p className="machines__desc">
                        Projeleriniz için operatörlü ve operatörsüz kiralama seçenekleriyle iş makinesi filomuz.
                    </p>
                </div>

                <div className="machines__carousel">
                    <button className="machines__arrow machines__arrow--prev" onClick={prev} aria-label="Önceki">
                        ‹
                    </button>

                    <div
                        className="machines__track"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        {machines.map((m, i) => {
                            const offset = getOffset(i, active);
                            const isVisible = Math.abs(offset) <= 2;
                            const isCenter = offset === 0;
                            const opacity = isCenter ? 1 : Math.abs(offset) === 1 ? 0.4 : 0.15;

                            return (
                                <div
                                    className="machines__slide"
                                    key={m.id}
                                    style={{
                                        transform: `translateX(${offset * 370}px)`,
                                        opacity: isVisible ? opacity : 0,
                                        filter: isCenter ? 'none' : `blur(${Math.abs(offset)}px)`,
                                        zIndex: 10 - Math.abs(offset),
                                        pointerEvents: isVisible ? 'auto' : 'none',
                                    }}
                                    onClick={() => !isCenter && setActive(i)}
                                >
                                    <div className="machine-card">
                                        <div className="machine-card__visual">
                                            <img src={m.image} alt={m.title} className="machine-card__img" />
                                        </div>
                                        <div className="machine-card__info">
                                            <h3 className="machine-card__title">{m.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button className="machines__arrow machines__arrow--next" onClick={next} aria-label="Sonraki">
                        ›
                    </button>
                </div>

                <div className="machines__dots">
                    {machines.map((_, i) => (
                        <button
                            key={i}
                            className={`machines__dot${i === active ? ' machines__dot--active' : ''}`}
                            onClick={() => setActive(i)}
                            aria-label={`Makine ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Machines;
